import { IssueDate } from '@contexts/Estate';
import { DniType } from '../enums';

export class DniCode {
  constructor(public readonly value: string) {}
}
export class Dni {
  constructor(public type: DniType, public code: DniCode, public issueDate?: IssueDate) {}

  isComplete() {
    return !!this.type && !!this.code && !!this.issueDate;
  }
}
